export default {
  "content": "<path d=\"M25.05.77a60.3 60.3 0 00-19.16 0C2.26 1.5 0 3.77 0 6.72v10.5c0 3 2.26 5.24 5.95 6a59.97 59.97 0 0019.13.02c3.6-.66 5.92-3 5.92-6V6.73c0-2.99-2.32-5.33-5.95-5.97zm-4.5 11.9l-7.75 4.5a.76.76 0 01-.4.11.92.92 0 01-.39-.09.77.77 0 01-.39-.69v-9c0-.27.15-.52.4-.66a.86.86 0 01.78 0l7.75 4.5c.23.14.37.38.37.64 0 .27-.14.51-.37.65v.05z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "31",
    "height": "24",
    "fill": "#fff",
    "viewBox": "0 0 31 24"
  }
};